<template>
  <div class="flex w-full pt-8 pb-2">
    <div class="w-1/3">
      <div class="w-full mb-3 h-3px bg-sw_primary" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-6 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div v-if="activeStep > 1">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-5 h-5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10 20a9.852 9.852 0 01-3.904-.78 10.519 10.519 0 01-3.153-2.163A10.52 10.52 0 01.78 13.904 9.851 9.851 0 010 10c0-1.381.26-2.683.78-3.904a10.52 10.52 0 012.163-3.153c.9-.901 1.952-1.622 3.153-2.162A9.852 9.852 0 0110 0c1.381 0 2.683.26 3.904.78a10.52 10.52 0 013.153 2.163c.901.9 1.622 1.952 2.162 3.153C19.74 7.317 20 8.62 20 10c0 1.381-.26 2.683-.78 3.904a10.519 10.519 0 01-2.163 3.153c-.9.901-1.952 1.622-3.153 2.162A9.852 9.852 0 0110 20zM6.306 8.589L4.234 10.87l4.925 4.504 7.177-8.198-2.312-2.012-5.105 5.826-2.613-2.402z" fill="#666"/></svg>
          </div>
          <div
            v-if="activeStep <= 1"
            class="flex items-center justify-center w-5 h-5 text-xs leading-none text-white rounded-full"
            :class="[ activeStep === 1 ? 'bg-sw_primary' : 'bg-gray-300' ]"
          >
            1
          </div>
        </div>
        <span class="px-1" :class="{ 'text-sw_primary font-bold': activeStep === 1, 'text-gray-600': activeStep > 1 }">{{ step1 }}</span>
      </div>
    </div>
    <div class="w-1/3">
      <div :class="['w-full h-3px mb-3', activeStep >= 2 ? 'bg-sw_primary': 'bg-gray-300']" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-6 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div v-if="activeStep > 2">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-5 h-5 xl:w-5 xl:h-5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10 20a9.852 9.852 0 01-3.904-.78 10.519 10.519 0 01-3.153-2.163A10.52 10.52 0 01.78 13.904 9.851 9.851 0 010 10c0-1.381.26-2.683.78-3.904a10.52 10.52 0 012.163-3.153c.9-.901 1.952-1.622 3.153-2.162A9.852 9.852 0 0110 0c1.381 0 2.683.26 3.904.78a10.52 10.52 0 013.153 2.163c.901.9 1.622 1.952 2.162 3.153C19.74 7.317 20 8.62 20 10c0 1.381-.26 2.683-.78 3.904a10.519 10.519 0 01-2.163 3.153c-.9.901-1.952 1.622-3.153 2.162A9.852 9.852 0 0110 20zM6.306 8.589L4.234 10.87l4.925 4.504 7.177-8.198-2.312-2.012-5.105 5.826-2.613-2.402z" fill="#666"/></svg>
          </div>
          <div
            v-if="activeStep <= 2"
            class="flex items-center justify-center w-5 h-5 text-xs leading-none rounded-full"
            :class="[ activeStep === 2 ? 'bg-sw_primary text-white' : 'text-white bg-gray-300' ]"
          >
            2
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold text-sw_primary': activeStep === 2, 'text-gray-600': activeStep > 2, 'text-gray-300': activeStep < 2 }">{{ step2 }}</span>
      </div>
    </div>
    <div class="w-1/3">
      <div :class="['w-full h-3px mb-3', activeStep >= 3 ? 'bg-sw_primary': 'bg-gray-300']" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-6 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div
            v-if="activeStep <= 3"
            class="flex items-center justify-center w-5 h-5 text-xs leading-none rounded-full"
            :class="[ activeStep === 3 ? 'bg-sw_primary text-white' : 'text-white bg-gray-300' ]"
          >
            3
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold text-sw_primary': activeStep === 3, 'text-gray-900': activeStep > 3, 'text-gray-300': activeStep < 3 }">{{ step3 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VoucherNavigation from '~components/navigation/step-navigation'

export default VoucherNavigation.extend()
</script>
